<template lang="pug">
  v-dialog(v-model='dialog' max-higth='500px' max-width='1200' persistent )
    template(v-slot:activator='{ on }' )
      v-tooltip(bottom='')
        template(v-slot:activator='{ on }')
          v-btn(color='secondary' icon v-on='on' @click='get(llave); dialog=true')
            v-icon(small) far fa-eye
        span Ver orden de compra
    v-card( justify='center' max-width='1200')
      v-row
        v-spacer
        Boton_imprimir(nombre_de_impresion='Documento_de_orden_compra')
        v-btn( @click='dialog=false' color='primary' icon ) 
          v-icon(small) fa-times
      v-container#Documento_de_orden_compra
        v-row
          table
            tr
              td 
                img#img(:src='Customers.logoUrl' height='60' width='auto')
              td
                h3.text-center 
                  span Orden de compra Nº :
                  span.grey--text.text--darken--4 {{Datos.creado_el | imprimir_año}}{{String(Datos.numero_de_orden_de_compra).padStart(4, 0)}}
              td
            
        v-row(justify='center' align='center' )
          v-col
            p 
              small Proveedor : 
              small.grey--text.text--darken--4 {{Datos.proveedor ? Datos.proveedor.name : ''}}
            p 
              small Documento :          
              small.grey--text.text--darken--4 {{Datos.proveedor ? Datos.proveedor.document : ''}}
            p 
              small Correo Electrónico :
              small.grey--text.text--darken--4 {{Datos.proveedor ? Datos.proveedor.email : ''}}
            p 
              small Correo adicional :   
              small.grey--text.text--darken--4 {{Datos.correo_adicional}}
            p 
              small Teléfono :           
              small.grey--text.text--darken--4 {{Datos.proveedor ? Datos.proveedor.phone : ''}}
          v-col
            p 
              small Calidad :                
              small.grey--text.text--darken--4 {{Datos.calidad}}
            p
              small  Garantía :               
              small.grey--text.text--darken--4 {{Datos.garantia}}
            p 
              small Medio de pago :          
              small.grey--text.text--darken--4 {{Datos.medio_de_pago ? Datos.medio_de_pago.description : ''}}
            p 
              small Condiciones de pago :          
              small.grey--text.text--darken--4 {{Datos.condiciones_de_pago }} días
            p 
              small Fecha :           
              small.grey--text.text--darken--4 {{Datos.creado_el | imprimir_fecha}} 
        v-row(justify='center' align='center' )
          v-col
            v-row
              v-data-table( dense :headers='headers' :items='Datos.items' item-key='key' align='center' hide-default-footer )
                template( v-slot:body.append)
                  tr
                    td( colspan="5")
                    td Valor Venta
                    td {{(Datos.items.map(({subtotal}) => subtotal).reduce((a,b)=> a + b , 0)).toFixed(2)}}
                  tr
                    td( colspan="5")
                    td IGV
                    td {{(Datos.items.map(({igv}) => igv).reduce((a,b)=> a + b , 0)).toFixed(2)}}
                  tr
                    td( colspan="5")
                    td Total
                    td {{(Datos.items.map(({total}) => total).reduce((a,b)=> a + b , 0)).toFixed(2)}}
          
              

        v-row
          v-col 
            h5 Notas :
            P 
              small ¿Correctamente envalado? 
              small.grey--text.text--darken--4 {{Datos.envalaje == true? 'Si':'No' }}
            P
              small ¿Incluye envío?          
              small.grey--text.text--darken--4 {{Datos.envio == true? 'Si':'No' }}
            p 
              small Observaciones :          
              small.grey--text.text--darken--4 {{Datos.Observaciones}}
            p 
              small Importante:
              small.grey--text.text--darken--2 {{registro_de_credenciales.filter(item=>item.slug == "terminos-y-condiciones-orden-compra")[0].valores.filter(item=>item.descripcion == "importante")[0].valor}}
            p 
              small Condiciones :
              small.grey--text.text--darken--2  {{registro_de_credenciales.filter(item=>item.slug == "terminos-y-condiciones-orden-compra")[0].valores.filter(item=>item.descripcion == "condiciones")[0].valor}}          
        v-row(justify='end')
          v-card.mt-5(flat)
            v-card-title
            v-card-text
              v-divider
              strong Emitido por: 
              span.grey--text.text--darken--4 {{Datos.creado_por}}
          v-card.mt-5(flat)
            v-card-title
            v-card-text
              v-divider
              strong Aprobado por: 
              span.grey--text.text--darken--4 {{Datos.aprobado_por}}
          
            
            
      v-row.d-print-none(justify='center' width='100%')
        v-container 
          v-row
            notificar_boton(:estado_del_documento  = 'Datos.estado_del_documento' :id = 'Datos.key'  )  
            v-spacer
            br
            v-btn( @click='dialog=false' color='primary' outlined rounded ) cerrar
</template>
<script>
import {mapActions, mapGetters, mapState, mapMutations} from 'vuex'
import sermep from '@/assets/sermep.png'
import moment from 'moment'
export default {
  data:()=>({
    sermep,
    dialog:false,

    headers:[
      {text:'Productos', value:'descripcion'},
      {text:'Codigo', value:'codigo'},
      {text:'Cantidad ', value:'cantidad'},
      {text:'IGV', value:'igv'},
      {text:'Unidad de medida', value:'nombre_unidad_de_medida'},
      {text:'Precio unitario', value:'precio_unitario'},
      {text:'Total', value:'total'}
    ],
  }),
  props:{
    llave : String,
    idCotizacion : String,
  },
  methods:{
    ...mapActions({
      get : 'Ordenes_de_compra/get',
      generar_entrada: 'Ordenes_de_compra/generar_entrada',
    }),

  },
  computed: {
    ...mapState({
      Datos :state=> state.Ordenes_de_compra.datos,
      Ordenes_de_compra: state=> state.Ordenes_de_compra,
      Customers: state=>state.Customers.data,
    }),
    ...mapGetters({
      registro_de_credenciales: 'Credenciales/registro'
    }),
  
  },
  components:{
    notificar_boton: ()=> import('.././componentes/notificar_boton'),
    
    Boton_imprimir:()=>import ('@/components/boton_imprimir')
  },

}
</script>